import {
  takeLatest,
  put,
} from 'redux-saga/effects';
import { getDashboards } from '@api/dashboards';
import { autoRequest } from '@api/createRequestStore';
import * as actions from './actions';
import * as types from './types';

function* afterRequest() {
  // TODO: can make be a callback for future chagnes
}

function* initRequest() {
  yield put(actions.initRequest());
}

function* fetching() {
  yield actions.fetching();
  try {
    yield autoRequest(getDashboards, types.SCOPE, {}, afterRequest);
  } catch (error) {
    console.error(error);
    throw error;
  }
}

function* watchInitRequest() {
  yield takeLatest([
    types.INIT,
  ], initRequest);
}

function* watchFetching() {
  yield takeLatest([
    types.GET_DASHBOARDS_LIST,
  ], fetching);
}

export default [
  watchInitRequest,
  watchFetching,
];
